import styled from "styled-components";
import { Divider, Drawer } from "antd";

export const Container = styled(Drawer)`
  .ant-drawer-body {
    padding: 24px 0px 10px 0px;
  }

  span.message {
    font-family: Asap;
    font-weight: normal;
    font-size: 16px;
    text-align: left;
    color: #4b4b4b;
  }

  .drawerForm {
    width: 100%;
    padding: 0px 24px;
    min-height: -moz-calc(100vh - 165px);
    min-height: -webkit-calc(100vh - 165px);
    min-height: calc(100vh - 165px);
  }

  .rowLabel {
    margin-bottom: 7px;
    margin-top: 19px;
  }

  label {
    font-family: "Asap", sans-serif;
    color: #9074bf;
    font-size: 14px;
    font-weight: bold;
    margin-left: 15px;

    &.withoutMarginLeft {
      margin-left: 0px;
    }
    &.error {
      color: #d44c4c;
    }
    &.default {
      color: #fe8d2a;
    }
  }
  .customStrong {
    font-size: 16px;
  }

  .title {
    color: #a5a5a5;
    font-family: "Asap", sans-serif;
    font-weight: bold;
    font-size: 14px;
  }

  .subTitle {
    color: #4b4b4b;
    font-family: "Asap", sans-serif;
    font-weight: bold;
    font-size: 25px;
  }

  .ant-row-flex.cardGrey {
    margin-top: 13px;
    padding: 15px 13px;
    border-radius: 5px !important;
    background: #f5f5f5 !important;

    label {
      font-family: Asap;
      font-weight: bold;
      font-size: 12px;
      text-align: left;
      color: #a5a5a5;
      margin: 0px !important;
      &.default {
        color: #fe8d2a;
      }
    }
  }

  .ant-row.rowInput {
    margin-top: 6px;
  }

  .tableButtonsDiv {
    display: flex;
    align-items: center;
    justify-content: flex-end;

    button {
      display: flex;
      justify-content: center !important;
      text-align: center !important;
      align-items: center !important;
      font-size: 14px !important;
      width: 77px !important;
      height: 30px !important;

      svg {
        margin-right: 3px !important;
      }
    }

    button:first-of-type {
      width: 116px !important;
      margin-right: 12px !important;
    }
  }

  .ant-switch-checked {
    background-color: #a9c133 !important;
  }
`;

export const ModalTitle = styled.span`
  font-size: 25px;
  font-family: "Asap", sans-serif;
  font-weight: bold;
  color: #4b4b4b;
`;

export const ButtonInputNumber = styled.button`
  background: transparent;
  color: #fff;
  border: none;
  width: 100% !important;
  height: 100% !important;

  &:hover {
    cursor: pointer;
  }

  svg {
    margin-left: 5px;
  }
`;

export const CustomDivider = styled(Divider)`
  margin: 10px 0 !important;

  .ant-divider-horizontal.ant-divider-with-text-center,
  .ant-divider-horizontal.ant-divider-with-text-left,
  .ant-divider-horizontal.ant-divider-with-text-right {
    margin: 10px 0 !important;
  }

  &.ant-divider-dashed {
    border-color: #e8e5e5 !important;
  }
  &.ant-divider-with-text-center::before,
  &.ant-divider-with-text-left::before,
  &.ant-divider-with-text-right::before,
  &.ant-divider-with-text-center::after,
  &.ant-divider-with-text-left::after,
  &.ant-divider-with-text-right::after {
    border-top: 1px dashed #e8e5e5 !important;
  }
  .ant-divider-inner-text {
    font-family: Asap;
    font-weight: bold;
    font-size: 14px;
    text-align: center;
    color: #a5a5a5;
  }
`;

export const ChartContainer = styled.div`
  width: 100%;
  height: 100%;
  margin-top: 16px !important;
`;

export const Footer = styled.div`
  border-top: 1px solid #e8e8e8;
  margin-top: 20px;
  width: 100%;
  padding: 10px 24px;
  border-radius: 0 0 4px 4px;

  .buttonsDiv {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    /* padding-right: 24px; */

    button:first-of-type {
      margin-right: 12px !important;
    }
  }

  .selectDiv {
    display: flex;
    align-items: center;
    justify-content: flex-start;

    span {
      font-family: "Asap", sans-serif;
      font-size: 14px;
      font-weight: bold;
      margin-right: 8px;
    }
  }
`;

export const LotCurveParameterCard = styled.div`
  width: 100%;
  border-radius: 6px;
  background: transparent;
  border: 1px dashed #fe8d2a;
  margin-top: 20px;

  .header {
    padding: 14px 12px 11px 12px;
    display: flex !important;
    align-items: center !important;
    text-align: center !important;

    span.title {
      font-family: Asap;
      font-weight: bold;
      font-size: 14px;
      text-align: left;
      color: #fe8d2a;
      text-align: center;
      svg {
        margin-right: 58px;
        g {
          path {
            fill: #fe8d2a !important;
            color: #fe8d2a !important;
          }
        }
      }
    }

    span.date {
      font-family: Asap;
      font-weight: normal;
      font-style: italic;
      font-size: 14px;
      text-align: right;
      color: #d44c4c;
    }
  }

  .discription {
    margin: 12px 10px;
    font-family: Asap;
    font-weight: normal;
    font-style: italic;
    font-size: 14px;
    text-align: left;
    color: #4b4b4b;
  }
`;
